<app-page [content]="content" />

<ng-template #content>
  <h1 class="text-bold m-b-5">Assessment completed</h1>

  <p>This assessment has already been completed, and can't be retaken.</p>
</ng-template>
